/*
キャンバス上をドラッグして使うツールとDOMを仲介するレイヤー。管理対象のツールは以下のメソッドが必須。

cancel: キャンセルボタンを押したとき一度だけ呼ばれる　引数なし
drag: 対象を掴んだ状態でマウスカーソルを移動したとき繰り返し呼ばれる　引数はマウスカーソルのx,y
finish: ボタンが正常に離されたとき一度だけ呼ばれる　引数なし
*/

import DPR from './DPR.js'

export default class DragToolManager {
  constructor(dragCamera, drawingToolKit, selection, imageResizer, changeCursor) {
    //-- public
    this.buttons = ['draw', 'move', 'eyedropper', '', ''];

    //-- private
    this._dragCamera = dragCamera;
    this._drawingToolKit = drawingToolKit;
    this._selection = selection;
    this._imageResizer = imageResizer;
    this._changeCursor = changeCursor;
    this._eyedropper = new Eyedropper(drawingToolKit);
    this._usingDragTool = null;
    this._usingDragButton = 0;

    //-- add event listeners
    this.mainCanvasMousedown = this.mainCanvasMousedown.bind(this);
    this.windowMousedown = this.windowMousedown.bind(this);
    this.windowMousemove = this.windowMousemove.bind(this);
    this.windowMouseup = this.windowMouseup.bind(this);

    const elMainCanvas = document.querySelector('#mainCanvas');
    const elRotateIcon = document.querySelector('#rotateIcon');

    elMainCanvas.addEventListener('mousedown', this.mainCanvasMousedown);
    elRotateIcon.addEventListener('mousedown', this.mainCanvasMousedown);
    window.addEventListener('mousedown', this.windowMousedown);
    window.addEventListener('mousemove', this.windowMousemove);
    window.addEventListener('mouseup', this.windowMouseup);
  }

  static MOUSE_BUTTONS_BITFLAGS = [1, 4, 2, 8, 16];

  isFree() {
    return this._usingDragTool === null;
  }

  mainCanvasMousedown(e) {
    if(!this._usingDragTool) {
      this._usingDragButton = e.button;
      const x = DPR.mul(e.x);
      const y = DPR.mul(e.y);
      switch(this.buttons[e.button]) {
      case 'draw':
        if(this._imageResizer.start(x, y)) {
          this._usingDragTool = this._imageResizer;
        } else {
          switch(this._drawingToolKit.getMode()) {
          case 'selection':
          case 'lasso':
            this._selection.start(x, y);
            this._usingDragTool = this._selection;
            this.updateCursor();
            break;
          default:
            this._drawingToolKit.start(x, y, e.detail);
            this._usingDragTool = this._drawingToolKit;
            break;
          }
        }
        break;
      case 'eyedropper':
        if(!this._selection.isSelecting()) {
          this._drawingToolKit.setMode('eyedropper');
          this._drawingToolKit.start(x, y);
          this._usingDragTool = this._eyedropper;
          this.updateCursor();
        }
        break;
      case 'move':
        this._changeCursor('var(--cursor-move)');
        this._dragCamera.start(x, y);
        this._usingDragTool = this._dragCamera;
        break;
      }
    }
  }
  windowMousedown(e) {
    if(this._usingDragTool && e.button !== this._usingDragButton) {
      this._usingDragTool.cancel();
      this._usingDragTool = null;
      this.updateCursor();
    }
    if(e.button === 1) e.preventDefault();  // ブラウザのデフォルトの移動カーソルを禁止
  }
  windowMousemove(e) {
    const x = DPR.mul(e.x);
    const y = DPR.mul(e.y);
    if(this._usingDragTool) {
      if(e.buttons & DragToolManager.MOUSE_BUTTONS_BITFLAGS[this._usingDragButton]) {
        this._usingDragTool.drag(x, y);
      } else {
        this._usingDragTool.cancel();
        this._usingDragTool = null;
      }
    } else {
      this._drawingToolKit.nodrag(x, y);
      this._selection.nodrag(x, y);
      this._imageResizer.nodrag(x, y);
      this.updateCursor();
    }
  }
  windowMouseup(e) {
    if(this._usingDragTool) {
      if(e.button === this._usingDragButton) {
        this._usingDragTool.finish();
        this._usingDragTool = null;
        this.updateCursor();
      }
    }
  }
  updateCursor() {
    let cursor = this._imageResizer.getCursor();
    if(!cursor) {
      switch(this._drawingToolKit.getMode()) {
      case 'selection':
      case 'lasso':
        cursor = this._selection.getCursor();
        break;
      default:
        cursor = this._drawingToolKit.getCursor();
        break;
      }
    }
    this._changeCursor(cursor);
  }

  draw(ctx) {
    this._imageResizer.draw(ctx);
    this._selection.draw(ctx);
  }
}

class Eyedropper {
  constructor(drawingToolKit) {
    this._drawingToolKit = drawingToolKit;
  }
  cancel() {
    this._drawingToolKit.cancel();
  }
  drag(x, y) {
    this._drawingToolKit.drag(x, y);
  }
  finish() {
    this._drawingToolKit.finish();
  }
}
